import { FontIcon, IStackTokens, Panel, PanelType, Stack } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ComboBox, IComboBoxProps } from 'office-ui-fabric-react/lib/ComboBox';
import Dialog, { DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, IDropdown, IDropdownOption, ResponsiveMode } from 'office-ui-fabric-react/lib/Dropdown';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { Separator } from 'office-ui-fabric-react/lib/Separator';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import Label from 'reactstrap/lib/Label';
import { IAgentCharges } from '../../../models/IAgentCharges';
import { IAgentJurisdiction } from '../../../models/IAgentJurisdiction';
import { ICharges } from '../../../models/ICharges';
import { ICountry } from '../../../models/ICountry';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import AgentChargesPreview from '../AgentChargesPreview/AgentChargesPreview';
import { IAgentChargesProps } from './IAgentChargesProps';
import { IAgentChargesState } from './IAgentChargesState';
initializeIcons();

const topPanel = mergeStyles({
    textAlign: 'center',
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "12px",
    color: '#005269',
    minWidth: '200px',
    top: "0",
    maxWidth: "100%"
});
const topMsgPanel = mergeStyles({
    textAlign: 'center',
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 1px 1px #C9C9C9',
    borderRadius: "5px",
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "12px",
    color: '#005269',
    minWidth: '200px',
    top: "0",
    maxWidth: "100%"
});
const disableInput = mergeStyles({
    pointerEvents: "none",
    opacity: "0.5"
});
const enableInput = mergeStyles({
    display: 'block'
});
const alertMsgPanel = mergeStyles({
    color: "#E9512D", fontSize: "13px", textAlign: "left"
});
const showAdditionalWindow = mergeStyles({
    padding: "5px",
    margin: "0px auto",
    overflowX: "auto",
    textAlign: "left",
    border: '1px solid #005269',
    borderRadius: "5px",
    fontSize: '12px',
    width: "100%",
    color: '#005269'
});
const responsiveMain = mergeStyles({
    margin: "0px auto",
    overflowX: "auto"
});
const responsiveTable = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    tableLayout: "fixed"
});
const responsiveTableContent = mergeStyles({
    display: "table",
    margin: '0 auto',
    width: "100%",
    border: "1px solid #005269"
});
const responsiveTableRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269"
});
const responsiveTableHeaderRow = mergeStyles({
    display: "table-row",
    border: "1px solid #005269",
    backgroundColor: '#005269', color: "#ffffff"

});
const responsiveTableBody = mergeStyles({
    display: "table-row-group"
});
const responsiveTableBodyCell = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle"
});
const responsiveTableBodyCellParticulars = mergeStyles({
    display: "table-cell",
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle",
    width: "40%"
});
const responsiveTableBodyCellRight = mergeStyles({
    display: "table-cell",
    padding: "5px",
    verticalAlign: "middle",
    textAlign: "right"
});
const textAlignCenter = mergeStyles({
    textAlign: "center"
});
const textAlignRight = mergeStyles({
    textAlign: "right"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
const thankYouWindow = mergeStyles({ color: "#005269", boxAlign: "center", fontSize: "12px", textAlign: "center" });
const thankYouWindowHeader = mergeStyles({ fontSize: "20px", fontWeight: "bold" });
const thankYouMessage = mergeStyles({ fontSize: "14px" });
export interface IDetailsListGroupedItem {
    key: number;
    particulars: string;
    officialfee: number;
    professionalfee: number;
    otherexpenses: number
    total: number;
    notapplicable: boolean;
}
export default class AgentCharges extends React.Component<IAgentChargesProps, IAgentChargesState>
{
    private connectionContext: ConnectionContext;
    private dialog: IModalDialog;
    private saving: boolean = false;
    private CountryError: string;
    private isActive: boolean;
    focusInput: React.RefObject<HTMLDivElement>;

    constructor(props: IAgentChargesProps, state: IAgentChargesState) {
        super(props);
        this.focusInput = React.createRef();
        this.focus = this.focus.bind(this);
        this.connectionContext = this.props.connectionContext;
        this.CountryError = '';
        this.isActive = false;

        this.state = {
            agentMaster: this.props.agentMaster,
            loading: false,
            isActive: {},
            inputError: 'This field is Required',
            showError: false,
            isValidData: true,
            Countries: [],
            selectedCountry: {
                key: '',
                text: ''
            },
            hideDialog: true,
            charges: [],
            agentCharges: [],
            agentJurisdiction: [],
            selectedcountries: '',
            agentChargesSaved: [],
            items: [],
            selectedItems: [],
            selectionDetails: [],
            additionalWindow: false,
            hideModel: true,
            isCompleted: false
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
    }
    public async focus() {
        const node = this.focusInput.current;
        if (node) {
            node.focus();
        }
    }
    private changeCountry(item: IDropdownOption) {
        this.setState((prevState: IAgentChargesState): IAgentChargesState => {
            prevState.selectedCountry = item;
            this.CountryError = item.text.trim().length > 0 ? '' : 'Select a jurisdiction';
            this.saving = false;
            return prevState;
        }, () => this.getAgentCharges());
    }
    public async componentDidMount() {
        if (this.state.agentMaster.id !== null && this.state.agentMaster.id !== undefined && this.state.agentMaster.id !== "") {
            this.getJurisdiction();
            this.getCharges();
            this.loadCountries();
        }
        this.focus();
    }
    private getJurisdiction = (): void => {
        var result: any = [];
        var selectedcountries = '';

        this.setState((prevState: IAgentChargesState): IAgentChargesState => {
            this.state.agentMaster.agentJurisdiction.sort((a, b) => a.countryName > b.countryName ? 1 : -1).forEach((item: IAgentJurisdiction) => {
                result.push({
                    key: item.countryCode, text: item.countryName
                });
                if (selectedcountries === '') {
                    selectedcountries = item.countryName;
                }
                else {
                    selectedcountries = selectedcountries + ', ' + item.countryName;
                }
            });
            prevState.selectedcountries = selectedcountries;
            prevState.Countries = result;
            return prevState;
        });
    }
    private getCharges = async (): Promise<void> => {
        try {
            var result: any = [];
            let agentCharges: ICharges[] = await this.connectionContext.get("Charges");
            this.setState((prevState: IAgentChargesState): IAgentChargesState => {
                prevState.charges = agentCharges;
                agentCharges.forEach((item: any) => {
                    result.push({
                        id: item.id, agentId: this.state.agentMaster.id, countryCode: item.countryCode, countryName: item.countryName, particulars: item.particulars, officialfee: item.officialfee | 0, professionalfee: item.professionalfee | 0,
                        otherexpenses: item.otherexpenses | 0, total: item.total | 0, category: item.category, notapplicable: false
                    });
                });
                prevState.agentCharges = result;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private getAgentCharges = async (): Promise<void> => {
        try {
            if (this.state.selectedCountry.text.toString() != null && this.state.selectedCountry.text.toString() !== "" && this.state.selectedCountry.text.toString() !== undefined) {
                let agentCharges: IAgentCharges[] = await this.connectionContext.get(`AgentCharges/${this.state.agentMaster.id}/${this.state.selectedCountry.key}`);
                this.setState((prevState: IAgentChargesState): IAgentChargesState => {
                    prevState.agentChargesSaved = agentCharges;
                    prevState.agentCharges = agentCharges;
                    this.isActive = false;
                    if (prevState.agentCharges.length === 0) {
                        this.getCharges();
                        this.isActive = true;
                    }
                    return prevState;
                });
            }
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private onNAClick = (item) => {
        const isChecked = item.target.checked;
        const key = item.target.accessKey;
        const value = item.target.value;
        this.setState((previousState: IAgentChargesState): IAgentChargesState => {
            previousState.agentCharges.forEach((tech: IAgentCharges) => {
                if (tech.particulars === value && tech.id === key) {
                    tech.notApplicable = isChecked;
                    tech.officialfee = 0;
                    tech.professionalfee = 0;
                    tech.otherexpenses = 0;
                    tech.total = 0;
                }
            });
            return previousState;
        });
    }
    private onOfficialFeeChange = (i, event) => {
        const value = event.target.value;
        const key = event.currentTarget.accessKey;

        this.setState((previousState: IAgentChargesState): IAgentChargesState => {
            previousState.agentCharges.forEach((tech: IAgentCharges) => {
                if (tech.id === key) {
                    const re = /^[0-9]\d*(\.\d+)?$/;
                    if (value.length < 1) {
                        tech.officialfee = 0;
                    }
                    else if (!re.test(value)) {
                        event.preventDefault();
                        tech.officialfee = 0;
                    }
                    else {
                        tech.officialfee = parseFloat(value);
                        tech.notApplicable = false;
                    }
                    tech.professionalfee = (tech.professionalfee === null || tech.professionalfee === 0 || tech.professionalfee === undefined) ? 0 : tech.professionalfee;
                    tech.otherexpenses = (tech.otherexpenses === null || tech.otherexpenses === 0 || tech.otherexpenses === undefined) ? 0 : tech.otherexpenses;;
                    tech.total = (tech.officialfee) + (tech.professionalfee) + (tech.otherexpenses);

                }
            });
            return previousState;
        });
    }
    private onProfessionalFeeChange = (i, event) => {
        const value = event.target.value;
        const key = event.currentTarget.accessKey;

        this.setState((previousState: IAgentChargesState): IAgentChargesState => {
            previousState.agentCharges.forEach((tech: IAgentCharges) => {
                if (tech.id === key) {
                    const re = /^[0-9]\d*(\.\d+)?$/;
                    if (value.length < 1) {
                        tech.professionalfee = 0;
                    }
                    else if (!re.test(value)) {
                        event.preventDefault();
                        tech.professionalfee = 0;
                    }
                    else {
                        tech.professionalfee = parseFloat(value);
                        tech.notApplicable = false;
                    }
                    tech.officialfee = (tech.officialfee === null || tech.officialfee === 0 || tech.officialfee === undefined) ? 0 : tech.officialfee;
                    tech.otherexpenses = (tech.otherexpenses === null || tech.otherexpenses === 0 || tech.otherexpenses === undefined) ? 0 : tech.otherexpenses;;
                    tech.total = (tech.officialfee) + (tech.professionalfee) + (tech.otherexpenses);
                }
            });
            return previousState;
        });
    }
    private onOtherExpensesChange = (i, event) => {
        const value = event.target.value;
        const key = event.currentTarget.accessKey;

        this.setState((previousState: IAgentChargesState): IAgentChargesState => {
            previousState.agentCharges.forEach((tech: IAgentCharges) => {
                if (tech.id === key) {
                    const re = /^[0-9]\d*(\.\d+)?$/;
                    if (value.length < 1) {
                        tech.otherexpenses = 0;
                    }
                    else if (!re.test(value)) {
                        event.preventDefault();
                        tech.otherexpenses = 0;
                    }
                    else {
                        tech.otherexpenses = parseFloat(value);
                        tech.notApplicable = false;
                    }
                    tech.professionalfee = (tech.professionalfee === null || tech.professionalfee === 0 || tech.professionalfee === undefined) ? 0 : tech.professionalfee;
                    tech.officialfee = (tech.officialfee === null || tech.officialfee === 0 || tech.officialfee === undefined) ? 0 : tech.officialfee;;
                    tech.total = (tech.officialfee) + (tech.professionalfee) + (tech.otherexpenses);
                }
            });
            return previousState;
        });
    }
    private closeChild = async (): Promise<void> => {
        this.setState((prevState: IAgentChargesState): IAgentChargesState => {
            prevState.hideDialog = true;
            this.isActive = false;
            return prevState;
        });
        await this.deactivateUser();
        this.focus();
    };
    private deactivateUser = async (): Promise<void> => {
        if (this.state.agentMaster.emailId) {
            try {
                let allCompleted: boolean = false;
                allCompleted = await this.props.connectionContext.put(`UserActivation/${this.state.agentMaster.emailId}/deactivate`, {});
                if (allCompleted) {
                    this.setState((prevState: IAgentChargesState): IAgentChargesState => {
                        prevState.isCompleted = true;
                        this.handleError("Thank you...", "Thank you for providing your best fees for the selected jurisdiction(s). You will receive an email notification to your registered email address. Click 'Ok' to proceed further.");
                        return prevState;
                    });
                }
            } catch (error) {
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
            }
        }
    }
    private cancelChild = () => {
        this.setState({
            hideDialog: true
        });
        this.focus();
    };
    public dismissPanel = (): void => {
        this.setState((prevState: IAgentChargesState): IAgentChargesState => {
            prevState.additionalWindow = false;
            return prevState;
        });
    }
    public render(): React.ReactElement<IAgentChargesProps> {
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const dropdownRef = React.createRef<IDropdown>();
        const trademarkitems = this.state.agentCharges.filter(tech => tech.category === "TRADE MARK");
        const patentsitems = this.state.agentCharges.filter(tech => tech.category === "PATENTS");
        const designitems = this.state.agentCharges.filter(tech => tech.category === "DESIGN");
        const hourlyrateitems = this.state.agentCharges.filter(tech => tech.category === "HOURLY RATE PROSECUTION");
        const handleFocus = (event) => event.target.select();
        const { items, selectionDetails } = this.state;
        return (
            <div>
                <div ref={this.focusInput}></div>
                <div className={topPanel} >
                    {
                        <div>
                            <div>
                                <Dialog
                                    hidden={this.state.hideModel}
                                    dialogContentProps={{
                                        type: DialogType.largeHeader,
                                        title: this.dialog.dialogMessage,
                                    }}
                                    maxWidth="1024px"
                                    closeButtonAriaLabel="Close"
                                >
                                    <div>
                                        <div>
                                            <Label> {this.dialog.dialogBody} </Label>
                                        </div>
                                    </div>
                                    <DialogFooter>
                                        <DefaultButton onClick={this.closeModelPopUp} data-automation-id="test" text="Ok" disabled={false}
                                            className={submitButton} iconProps={{ iconName: "CheckMark" }} />
                                    </DialogFooter>
                                </Dialog>

                            </div>
                        </div>
                    }
                    {
                        <div>
                            <div>
                                <Dialog
                                    hidden={this.state.hideDialog}
                                    dialogContentProps={{
                                        type: DialogType.close
                                    }}
                                    minWidth="90%"
                                    closeButtonAriaLabel="Ok"
                                    onDismiss={this.cancelChild}
                                >
                                    <div>
                                        <div>
                                            <AgentChargesPreview connectionContext={this.connectionContext}
                                                agentCharges={this.state.agentCharges} onCancel={this.cancelChild} onClose={this.closeChild}
                                                selectedCountry={this.state.selectedCountry.text} selectedcountries={this.state.selectedcountries} />
                                        </div>
                                    </div>
                                </Dialog>
                            </div>
                        </div>
                    }
                    {
                        <Panel
                            isOpen={this.state.additionalWindow}
                            onDismiss={this.dismissPanel}
                            type={PanelType.smallFixedFar}
                            closeButtonAriaLabel="Close"
                            headerText={"Add more jurisdiction(s)"}
                        >
                            <Separator></Separator>
                            <div className={showAdditionalWindow}>
                                <div className={responsiveTable}>
                                    <div className={responsiveTableBody}>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>Service Offered for: </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div>
                                                    <ComboBox
                                                        placeholder="--Select or type--"
                                                        autoComplete="on"
                                                        allowFreeform
                                                        options={items}
                                                        onChange={this.onChangeJurisdiction}
                                                        multiSelect
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div>
                                                    {
                                                        selectionDetails.map((tech, i) => {
                                                            if (i === 0) {
                                                                return (
                                                                    <strong>{tech.toString()}</strong>
                                                                )
                                                            }
                                                            else {
                                                                return (
                                                                    <strong>, {tech.toString()}</strong>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className={responsiveTableRow}>
                                            <div className={responsiveTableBodyCell}>
                                                <div>
                                                    <PrimaryButton text="Save" data-automation-id="test" onClick={this.addJurisdiction} className={submitButton} iconProps={{ iconName: 'SaveAndClose' }} />
                                                    <PrimaryButton text="Cancel" data-automation-id="test" onClick={this.hideAdditionalWindow} className={submitButton} iconProps={{ iconName: 'Cancel' }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    }
                    {
                        (!this.saving && !this.state.isCompleted) && (
                            <div>
                                <div>
                                    <div className={topMsgPanel}>You have chosen <strong>{this.state.selectedcountries}</strong> as your service available jurisdiction</div>
                                    <div className={responsiveMain}>
                                        <div className={responsiveTable}>
                                            <div className={responsiveTableBody}>
                                                <div className={responsiveTableRow}>
                                                    <div className={responsiveTableBodyCell}>
                                                    </div>
                                                    <div className={responsiveTableBodyCellRight}>Enter/view the charges for:</div>
                                                    <div className={responsiveTableBodyCell}>
                                                        <Stack horizontal tokens={stackTokens} verticalAlign="center">
                                                            <Dropdown
                                                                id="ddjur"
                                                                placeHolder="--Select--"
                                                                componentRef={dropdownRef} responsiveMode={ResponsiveMode.large}
                                                                options={this.state.Countries}
                                                                styles={{ dropdown: { minWidth: 220 } }}
                                                                onChanged={this.changeCountry.bind(this)}
                                                                errorMessage={this.CountryError}
                                                            />
                                                        </Stack>
                                                    </div>
                                                    <div className={responsiveTableBodyCell}>
                                                        <PrimaryButton text="Add more" onClick={this.showAdditionalWindow}
                                                            className={submitButton} iconProps={{ iconName: 'CircleAdditionSolid' }} />
                                                    </div>
                                                    <div className={responsiveTableBodyCell}>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {(this.isActive &&
                                        <div className={textAlignCenter}>Now you are entering charges for: <strong>{this.state.selectedCountry.text.toString()}</strong></div>)}
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>TRADE MARK</h6>
                                        <div className={responsiveMain}>
                                            <div className={responsiveTableContent}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableHeaderRow}>
                                                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Official fee (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Professional fee (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Other fee (if applicable) (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                    </div>
                                                    {
                                                        trademarkitems.map((tech, i) => {
                                                            return (
                                                                <div className={responsiveTableRow}>
                                                                    <div className={responsiveTableBodyCellParticulars}><p>{tech.particulars}</p></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.officialfee} accessKey={tech.id} onChange={e => this.onOfficialFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.professionalfee} accessKey={tech.id} onChange={e => this.onProfessionalFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.otherexpenses} accessKey={tech.id} onChange={e => this.onOtherExpensesChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.total} disabled accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="checkbox" value={tech.particulars} checked={tech.notApplicable} onChange={this.onNAClick} accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>PATENTS</h6>
                                        <div className={responsiveMain}>
                                            <div className={responsiveTableContent}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableHeaderRow}>
                                                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Official fee (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Professional fee (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Other fee (if applicable) (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                    </div>
                                                    {
                                                        patentsitems.map((tech, i) => {
                                                            return (
                                                                <div className={responsiveTableRow}>
                                                                    <div className={responsiveTableBodyCellParticulars}><p>{tech.particulars}</p></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.officialfee} accessKey={tech.id} onChange={e => this.onOfficialFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.professionalfee} accessKey={tech.id} onChange={e => this.onProfessionalFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.otherexpenses} accessKey={tech.id} onChange={e => this.onOtherExpensesChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.total} disabled accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="checkbox" value={tech.particulars} checked={patentsitems[i].notApplicable} onChange={this.onNAClick} accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>DESIGN</h6>
                                        <div className={responsiveMain}>
                                            <div className={responsiveTableContent}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableHeaderRow}>
                                                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Official fee (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Professional fee (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Other fee (if applicable) (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                    </div>
                                                    {
                                                        designitems.map((tech, i) => {
                                                            return (
                                                                <div className={responsiveTableRow}>
                                                                    <div className={responsiveTableBodyCellParticulars}><p>{tech.particulars}</p></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.officialfee} accessKey={tech.id} onChange={e => this.onOfficialFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.professionalfee} accessKey={tech.id} onChange={e => this.onProfessionalFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.otherexpenses} accessKey={tech.id} onChange={e => this.onOtherExpensesChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.total} disabled accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="checkbox" value={tech.particulars} checked={designitems[i].notApplicable} onChange={this.onNAClick} accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.isActive ? enableInput : disableInput}>
                                        <Separator></Separator>
                                        <h6>HOURLY RATE PROSECUTION</h6>
                                        <div className={responsiveMain}>
                                            <div className={responsiveTableContent}>
                                                <div className={responsiveTableBody}>
                                                    <div className={responsiveTableHeaderRow}>
                                                        <div className={responsiveTableBodyCell}><p><strong>Type of Service </strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Paralegal level (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Associate level  (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Partner level (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>Total (€)</strong></p></div>
                                                        <div className={responsiveTableBodyCell}><p className={textAlignRight}><strong>N.A</strong></p></div>
                                                    </div>
                                                    {
                                                        hourlyrateitems.map((tech, i) => {
                                                            return (
                                                                <div className={responsiveTableRow}>
                                                                    <div className={responsiveTableBodyCellParticulars}><p>{tech.particulars}</p></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.officialfee} accessKey={tech.id} onChange={e => this.onOfficialFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.professionalfee} accessKey={tech.id} onChange={e => this.onProfessionalFeeChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.otherexpenses} accessKey={tech.id} onChange={e => this.onOtherExpensesChange(i, e)} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="text" className={textAlignRight} value={tech.total} disabled accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                    <div className={responsiveTableBodyCellRight}><input type="checkbox" value={tech.particulars} checked={hourlyrateitems[i].notApplicable} onChange={this.onNAClick} accessKey={tech.id} onFocus={handleFocus} /></div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {(this.isActive &&
                                    <div>
                                        <div className={alertMsgPanel}>Please make sure you have entered the correct values before submitting. Once submitted, it cannot be modified.
                                            In future, if there is any correction in the charges, please contact agent.network@zacco.com.
                                        </div>
                                        <span className={alertMsgPanel}>*</span>Mandatory<br />
                                        <PrimaryButton text="Preview & Submit" onClick={this.submitForm} className={submitButton}
                                            iconProps={{ iconName: 'ComplianceAudit' }} />
                                    </div>)
                                }
                            </div>
                        )
                    }
                    {
                        (this.state.isCompleted) && (
                            <div className={thankYouWindow} >
                                <div>
                                    <p className={thankYouWindowHeader}><FontIcon iconName="Completed" /></p>
                                </div>
                                <div>
                                    <p className={thankYouWindowHeader}>Thank you</p>
                                </div>
                                <div>
                                    <p className={thankYouMessage}>Your submission is received and our team will validate your information.</p>
                                </div>
                                <div>
                                    <p className={thankYouMessage}>You can send a request to <a href="mailto:agent.network@zacco.com" target="_blank" rel="noopener noreferrer">agent.network@zacco.com</a>, if you want to add/modify your information.</p>
                                    <p className={thankYouMessage}>Thank you for your interest in Zacco.</p>
                                    <p className={thankYouMessage}><strong>Best regards<br />Zacco Agent Network Team.</strong></p>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
    private loadCountries = async (): Promise<void> => {
        try {
            var result: any = [];
            var isExists: boolean = false;
            let countryList: ICountry[] = await this.props.connectionContext.get("Country");
            this.setState((prevState: IAgentChargesState): IAgentChargesState => {
                countryList = countryList.sort((a, b) => a.countryName > b.countryName ? 1 : -1)
                countryList.forEach((item: ICountry) => {
                    isExists = false;
                    prevState.agentMaster.agentJurisdiction.forEach((listitem: IAgentJurisdiction) => {
                        if (item.countryName === listitem.countryName) {
                            isExists = true;
                        }
                    });
                    if (!isExists) {
                        result.push(
                            { key: item.countryCode, text: item.countryName })
                    }
                });
                prevState.items = result;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private onChangeJurisdiction: IComboBoxProps['onChange'] = (event, option): void => {
        if (option) {
            this.setState((prevState: IAgentChargesState): IAgentChargesState => {
                const newSelectedItems = [...this.state.selectedItems];
                if (option.selected) {
                    newSelectedItems.push(option.key as string);
                    prevState.agentJurisdiction.push({ id: undefined, agentId: this.state.agentMaster.id || undefined, countryCode: option.key.toString(), countryName: option.text });
                    prevState.selectedItems = newSelectedItems;
                    prevState.selectionDetails.push(option.text);
                }
                else {
                    const currIndex = newSelectedItems.indexOf(option.key as string);
                    if (currIndex > -1) {
                        newSelectedItems.splice(currIndex, 1);
                        prevState.selectedItems = newSelectedItems;
                        prevState.agentJurisdiction.forEach((listitem: IAgentJurisdiction) => {
                            if (option.text === listitem.countryName) {
                                let index = this.state.agentJurisdiction.indexOf(listitem);
                                prevState.agentJurisdiction = prevState.agentJurisdiction.slice(0, index).concat(prevState.agentJurisdiction.slice(index + 1));
                            }
                        });
                        prevState.selectionDetails.forEach((listitem: string) => {
                            if (option.text === listitem) {
                                let index = this.state.selectionDetails.indexOf(listitem);
                                prevState.selectionDetails = prevState.selectionDetails.slice(0, index).concat(prevState.selectionDetails.slice(index + 1));
                            }
                        });
                    }
                }
                return prevState;
            });
        }
    }
    private submitForm = (): void => {
        if (this.checkMandatoryFields()) {
            this.setState((previousState: IAgentChargesState): IAgentChargesState => {
                previousState.agentCharges.forEach((agent: IAgentCharges) => {
                    agent.countryCode = this.state.selectedCountry.key.toString();
                    agent.countryName = this.state.selectedCountry.text.toString();
                });
                previousState.hideDialog = false;
                return previousState;
            });
        }
    }
    private addJurisdiction = async (): Promise<void> => {
        try {
            if (this.state.agentJurisdiction.length > 0) {
                await this.props.connectionContext.post("AgentJurisdiction", this.state.agentJurisdiction);
                this.setState((prevState: IAgentChargesState): IAgentChargesState => {
                    prevState.isValidData = true;
                    prevState.additionalWindow = false;
                    this.state.agentJurisdiction.forEach((item: IAgentJurisdiction) => {
                        prevState.agentMaster.agentJurisdiction.push(item);
                    })
                    prevState.agentJurisdiction = [];
                    prevState.selectionDetails = [];
                    this.handleError("Agent charges", "Additional jurisdictions are added to your profile!");
                    return prevState;
                });
                this.getJurisdiction();
                this.loadCountries();
            }
        } catch (e) {
            this.setState((prevState: IAgentChargesState): IAgentChargesState => {
                prevState.isValidData = false;
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                return prevState;
            });
        }
    }
    private showAdditionalWindow = (): void => {
        this.setState((previousState: IAgentChargesState, props: IAgentChargesProps): IAgentChargesState => {
            previousState.additionalWindow = true;
            return previousState;
        });
    }
    private hideAdditionalWindow = (): void => {
        this.setState((previousState: IAgentChargesState, props: IAgentChargesProps): IAgentChargesState => {
            previousState.agentJurisdiction = [];
            previousState.selectionDetails = [];
            previousState.additionalWindow = false;
            return previousState;
        });
    }
    private closeModelPopUp = () => {
        this.setState((previousState: IAgentChargesState, props: IAgentChargesProps): IAgentChargesState => {
            previousState.hideModel = true;
            return previousState;
        });
    }
    private checkMandatoryFields(): boolean {
        let validState: boolean = true;
        let selectedCountry: boolean = this.state.selectedCountry.text.trim().length > 0;
        let datalength: boolean = this.state.agentCharges.length > 0;
        if (!selectedCountry) {
            this.CountryError = 'Select a jurisdiction';
            validState = false;
        }
        if (!datalength) {
            validState = false;
        }
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentChargesState, props: IAgentChargesProps): IAgentChargesState => {
            previousState.hideModel = false;
            return previousState;
        });
    }
}